/* En-tête MBTB : bandeau rotatif, tiroir mobile, déroulants tactiles */
(function () {
  'use strict';

  class MbtbHeader extends HTMLElement {
    connectedCallback() {
      this.initAnnouncements();
      this.initDrawer();
      this.initTouchDropdowns();
    }

    disconnectedCallback() {
      if (this._timer) clearInterval(this._timer);
      document.body.classList.remove('mbtb-locked');
    }

    /* ---------- bandeau rotatif ---------- */
    initAnnouncements() {
      var wrap = this.querySelector('.mbtb-hdr__ann');
      if (!wrap) return;
      var items = Array.prototype.slice.call(wrap.querySelectorAll('.mbtb-hdr__ann-item'));
      if (items.length < 2) return;
      var delay = parseInt(wrap.getAttribute('data-ann-speed'), 10) || 5000;
      var i = 0;
      this._timer = setInterval(function () {
        items[i].classList.remove('is-on');
        items[i].classList.add('is-out');
        var prev = items[i];
        setTimeout(function () { prev.classList.remove('is-out'); }, 550);
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, delay);
    }

    /* ---------- tiroir mobile ---------- */
    initDrawer() {
      var self = this;
      var drawer = this.querySelector('.mbtb-drawer');
      var opener = this.querySelector('[data-drawer-open]');
      if (!drawer || !opener) return;

      function open() {
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        opener.setAttribute('aria-expanded', 'true');
        document.body.classList.add('mbtb-locked');
        var first = drawer.querySelector('.mbtb-drawer__close');
        if (first) first.focus();
      }
      function close() {
        drawer.classList.remove('is-open');
        opener.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mbtb-locked');
        setTimeout(function () { drawer.hidden = true; }, 420);
        opener.focus();
      }

      opener.addEventListener('click', open);
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !drawer.hidden) close();
      });
      self._closeDrawer = close;
    }

    /* ---------- déroulants au tactile ---------- */
    initTouchDropdowns() {
      if (!window.matchMedia('(hover: none)').matches) return;
      this.querySelectorAll('.mbtb-hdr__item.has-sub > .mbtb-hdr__link').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var item = link.parentElement;
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            item.parentElement.querySelectorAll('.is-open').forEach(function (o) {
              if (o !== item) o.classList.remove('is-open');
            });
            item.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
          }
        });
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.mbtb-hdr__item')) {
          document.querySelectorAll('.mbtb-hdr__item.is-open').forEach(function (o) {
            o.classList.remove('is-open');
            var l = o.querySelector('.mbtb-hdr__link');
            if (l) l.setAttribute('aria-expanded', 'false');
          });
        }
      });
    }
  }

  if (!customElements.get('mbtb-header')) customElements.define('mbtb-header', MbtbHeader);
})();
